import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import classNames from 'classnames';
import isEmpty from 'lodash/isEmpty';
import { FormattedMessage } from 'react-intl';
import messages from 'aurora-translations';
import ADGMImage from '../../../ADGMImage';
import styles from './styles';

function DocumentsReview(props) {
  const { classes, title, documents, documentType, onView } = props;

  const handleFileView = subType => {
    onView && onView(documentType, subType);
  };

  return (
    <Accordion defaultExpanded>
      <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classNames(classes.accordionTitleHead)}>
        <ADGMImage name='DocumentBlack.svg' alt='document' />
        <Typography component='p'>
          {messages[title?.key]?.id ? <FormattedMessage {...messages[title?.key]} values={title.values} /> : title?.key}
        </Typography>
      </AccordionSummary>
      <AccordionDetails className={classes.accordionDetails}>
        {!isEmpty(documents) && (
          <div className={classes.docsFlexContainer}>
            {(documents || []).map(doc => (
              <div key={doc.id} className={classNames(classes.fileFlex)}>
                <ADGMImage name='PDF.svg' alt='pdf' />
                <Typography component='p'>{doc.fileName}</Typography>
                <Button onClick={() => handleFileView(doc.subType)}>
                  <FormattedMessage {...messages.view} />
                </Button>
              </div>
            ))}
          </div>
        )}
      </AccordionDetails>
    </Accordion>
  );
}

DocumentsReview.propTypes = {
  classes: PropTypes.object.isRequired,
  onView: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  documentType: PropTypes.string.isRequired,
  documents: PropTypes.array.isRequired,
};

export default withStyles(styles)(DocumentsReview);
